<template>
    <div class="text-xs-center">
      <v-dialog
        v-model="loader"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="light-blue darken-3"
          dark
        >
          <v-card-text>
            {{ loaderText }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
  export default {
    name: 'my-loader',
    data: () => ({
      dialog: ''
    }),

    watch: {
    },

    computed: {
      loader: {

          get() {
            return this.$store.getters.loader
          },

        set() {
          this.$store.commit('setLoader', newValue)
        }
      },

      loaderText() {
        return this.$store.getters.loaderText
      }
    }
  }
</script>